import PropTypes from 'prop-types';
import React from "react";

import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";
import GuestMiddleware from "./routes/middleware/GuestMiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import HeaderOnlyLayout from "./components/HeaderOnlyLayout";

// Import performance components
import TopProgressBar from "./components/Common/TopProgressBar";
import PrefetchManager from "./components/Common/PrefetchManager";
import OnboardingModalManager from "./components/Common/OnboardingModalManager";

// Import scss
import "./assets/scss/theme.scss";
// Import Css
import 'bootstrap/dist/css/bootstrap.min.css';
// Modern Font Awesome (includes brand icons like fa-tiktok missing from the
// vendored/legacy icon set in theme.scss)
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/tutorial-guide.css';
import './styles/platform-icons.css';

// Import Chat History Context
import { ChatHistoryProvider } from "./contexts/ChatHistoryContext";
// Import Onboarding Context
import { OnboardingProvider } from "./contexts/OnboardingContext";
// Import Platforms Context
import { PlatformsProvider } from "./contexts/PlatformsContext";
// Import GA4 Analytics
import { AnalyticsProvider, AutoPageTracker } from "./analytics";
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import Fack Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = props => {
  function getLayout() {
    let layoutCls = VerticalLayout;

    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();
  return (
    <React.Fragment>
      <AnalyticsProvider>
        <ChatHistoryProvider>
          <OnboardingProvider>
            <PlatformsProvider>
              <TopProgressBar />
              <PrefetchManager />
              <OnboardingModalManager />
              <AutoPageTracker />
              <Routes>
              {authRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    route.path === "/logout" ? (
                      <NonAuthLayout>
                        {route.component}
                      </NonAuthLayout>
                    ) : (
                      <GuestMiddleware>
                        <NonAuthLayout>
                          {route.component}
                        </NonAuthLayout>
                      </GuestMiddleware>
                    )
                  }
                  key={idx}
                  isAuthProtected={false}
                />
              ))}

              {userRoutes.map((route, idx) => {
                const isPublic = route.auth === false;
                const isContactUs = route.path === "/contact-us";
                const isSidequestPreRegister = route.path === "/sidequest/pre-register";
                const isReport = route.path === "/report" || route.path === "/report/:slug";
                const isStoreValidatorPreview = route.path === "/store-validator/preview";

                // Special handling for contact us, sidequest pre-register, the standalone Report
                // page, and the Store Validator preview page (a store-listing mockup that must
                // render with no site header/sidebar, same as Report)
                if (isContactUs || isSidequestPreRegister || isReport || isStoreValidatorPreview) {
                  return (
                    <Route
                      path={route.path}
                      element={
                        <NonAuthLayout>
                          {route.component}
                        </NonAuthLayout>
                      }
                      key={idx}
                      isAuthProtected={false}
                      exact={route.exact}
                    />
                  );
                }
                
                const element = isPublic ? (
                  <NonAuthLayout>
                    <Layout>
                      {route.component}
                    </Layout>
                  </NonAuthLayout>
                ) : (
                  <Authmiddleware>
                    <Layout>
                      {route.component}
                    </Layout>
                  </Authmiddleware>
                );

                return (
                  <Route
                    path={route.path}
                    element={element}
                    key={idx}
                    isAuthProtected={!isPublic}
                    exact={route.exact}
                  />
                );
              })}
            </Routes>
            </PlatformsProvider>
          </OnboardingProvider>
        </ChatHistoryProvider>
      </AnalyticsProvider>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);